import { type SurveyUserV2 } from '@capsicum/common';
import styled from 'styled-components';

import { useSurveyAnswerGroup } from '../../hooks';
import { SurveyAnswer } from '../survey-answer/SurveyAnswer';

export type SurveyAnswerGroupProps = {
	answers: SurveyUserV2['answers'];
	hasUserVoted: boolean;
	isSurveyExpired: boolean;
	isUserVotePendingBlockchain: boolean;
	onAnswerChange: (answerId: string) => void;
	testID: string;
	userCanVote: boolean;
};

export const SurveyAnswerGroup = ({
	answers = [],
	hasUserVoted,
	isSurveyExpired,
	isUserVotePendingBlockchain,
	onAnswerChange,
	testID,
	userCanVote
}: SurveyAnswerGroupProps) => {
	const { getAnswerFormattedData, onAnswerPress } = useSurveyAnswerGroup({
		hasUserVoted,
		isSurveyExpired,
		isUserVotePendingBlockchain,
		onAnswerChange,
		userCanVote
	});

	return (
		<S.AnswerGroup data-testid={testID}>
			{answers.map((answer, index) => {
				const { hasModalFor, key, mediaItems, showRadioButton, status, text, thumbnailUrl } =
					getAnswerFormattedData(answer, index);

				return (
					<SurveyAnswer
						hasModalFor={hasModalFor}
						id={key}
						key={key}
						mediaItems={mediaItems}
						showRadioButton={showRadioButton}
						status={status}
						testID={`${testID}Option-${answer.id}`}
						text={text}
						thumbnailUrl={thumbnailUrl}
						onAnswerPress={onAnswerPress}
					/>
				);
			})}
		</S.AnswerGroup>
	);
};

namespace S {
	export const AnswerGroup = styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.large};
	`;
}
